<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    heightNumber: {
      type: Number,
      default: 120
    },
    arrIndexHidden: {
      type: Array,
      default () {
        return []
      }
    }
  },
  mounted () {
    this.$refs.canvas.height = this.heightNumber
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    arrIndexHidden (arrIndex) {
      if (arrIndex.length) {
        for (let index of arrIndex) {
          this.$data._chart.getDatasetMeta(index).hidden = true
        }
        this.$data._chart.update()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue